/**
 * Outline colours tying a delivery fee card to the parcels it covers.
 *
 * Written out in full rather than composed from a colour name: Tailwind scans
 * source text for class names, so a class built at runtime is never generated.
 */
export const DELIVERY_PALETTE = [
   { border: "border-teal-500",   bg: "bg-teal-50/60",   dot: "bg-teal-500",   ring: "ring-teal-400" },
   { border: "border-amber-500",  bg: "bg-amber-50/60",  dot: "bg-amber-500",  ring: "ring-amber-400" },
   { border: "border-violet-500", bg: "bg-violet-50/60", dot: "bg-violet-500", ring: "ring-violet-400" },
   { border: "border-rose-500",   bg: "bg-rose-50/60",   dot: "bg-rose-500",   ring: "ring-rose-400" },
   { border: "border-sky-500",    bg: "bg-sky-50/60",    dot: "bg-sky-500",    ring: "ring-sky-400" },
   { border: "border-lime-600",   bg: "bg-lime-50/60",   dot: "bg-lime-600",   ring: "ring-lime-500" },
];

export const paletteFor = (index) =>
   DELIVERY_PALETTE[index % DELIVERY_PALETTE.length];
